import React from "react";
import "./HiringCompanies.css";

/*
 * Hyderabad Technology Ecosystem
 *
 * Company logos are loaded from Simple Icons CDN.
 * No logo files are required inside public/images.
 *
 * These companies are shown as part of the technology ecosystem.
 * They should not be described as PRT hiring partners unless
 * PRT Academy has separately confirmed that relationship.
 */

const companies = [
    {
        name: "Microsoft",
        logo: "https://cdn.simpleicons.org/microsoft",
    },
    {
        name: "Google",
        logo: "https://cdn.simpleicons.org/google",
    },
    {
        name: "Amazon",
        logo: "https://cdn.simpleicons.org/amazon",
    },
    {
        name: "Apple",
        logo: "https://cdn.simpleicons.org/apple",
    },
    {
        name: "Salesforce",
        logo: "https://cdn.simpleicons.org/salesforce",
    },
    {
        name: "Oracle",
        logo: "https://cdn.simpleicons.org/oracle",
    },
    {
        name: "ServiceNow",
        logo: "https://cdn.simpleicons.org/servicenow",
    },
    {
        name: "IBM",
        logo: "https://cdn.simpleicons.org/ibm",
    },
    {
        name: "Accenture",
        logo: "https://cdn.simpleicons.org/accenture",
    },
    {
        name: "Deloitte",
        logo: "https://cdn.simpleicons.org/deloitte",
    },
    {
        name: "Cognizant",
        logo: "https://cdn.simpleicons.org/cognizant",
    },
    {
        name: "Capgemini",
        logo: "https://cdn.simpleicons.org/capgemini",
    },
    {
        name: "TCS",
        logo: "https://cdn.simpleicons.org/tcs",
    },
    {
        name: "Infosys",
        logo: "https://cdn.simpleicons.org/infosys",
    },
    {
        name: "Wipro",
        logo: "https://cdn.simpleicons.org/wipro",
    },
    {
        name: "HCLTech",
        logo: "https://cdn.simpleicons.org/hcl",
    },
    {
        name: "Tech Mahindra",
        logo: "https://cdn.simpleicons.org/techmahindra",
    },
    {
        name: "Qualcomm",
        logo: "https://cdn.simpleicons.org/qualcomm",
    },
    {
        name: "NVIDIA",
        logo: "https://cdn.simpleicons.org/nvidia",
    },
    {
        name: "AMD",
        logo: "https://cdn.simpleicons.org/amd",
    },
    {
        name: "Intel",
        logo: "https://cdn.simpleicons.org/intel",
    },
    {
        name: "ADP",
        logo: "https://cdn.simpleicons.org/adp",
    },
    {
        name: "JPMorgan Chase",
        logo: "https://cdn.simpleicons.org/jpmorgan",
    },
    {
        name: "Wells Fargo",
        logo: "https://cdn.simpleicons.org/wellsfargo",
    },
    {
        name: "HSBC",
        logo: "https://cdn.simpleicons.org/hsbc",
    },
    {
        name: "Meta",
        logo: "https://cdn.simpleicons.org/meta",
    },
    {
        name: "Uber",
        logo: "https://cdn.simpleicons.org/uber",
    },
    {
        name: "Freshworks",
        logo: "https://cdn.simpleicons.org/freshworks",
    },
    {
        name: "Cisco",
        logo: "https://cdn.simpleicons.org/cisco",
    },
    {
        name: "Adobe",
        logo: "https://cdn.simpleicons.org/adobe",
    },
];

const HiringCompanies = () => {
    return (
        <section className="hiring-companies-section">

            {/* ================= HEADER ================= */}

            <div className="hiring-companies-header">

                <span className="hiring-companies-badge">
                    HYDERABAD TECH ECOSYSTEM
                </span>

                <h2>
                    Leading Companies in
                    <span>Hyderabad's Tech Ecosystem</span>
                </h2>

                <p>
                    Explore leading technology, consulting, financial
                    services and product companies with a presence
                    in Hyderabad's growing technology ecosystem.
                </p>

            </div>


            {/* ================= COMPANY LOGOS ================= */}

            <div className="companies-marquee">

                <div className="companies-track">

                    {[...companies, ...companies].map(
                        (company, index) => (
                            <div
                                className="company-logo-card"
                                key={`${company.name}-${index}`}
                            >

                                {/* COMPANY NUMBER */}

                                <div className="company-logo-number">
                                    {String(
                                        (index % companies.length) + 1
                                    ).padStart(2, "0")}
                                </div>


                                {/* COMPANY LOGO */}

                                <img
                                    src={company.logo}
                                    alt={`${company.name} logo`}
                                    className="company-logo-image"
                                    loading="lazy"
                                    onError={(event) => {
                                        event.currentTarget.style.display =
                                            "none";
                                    }}
                                />


                                {/* COMPANY NAME */}

                                <span className="company-logo-label">
                                    {company.name}
                                </span>

                            </div>
                        )
                    )}

                </div>

            </div>


            {/* ================= BOTTOM MESSAGE ================= */}

            <div className="hiring-companies-bottom">

                <div>

                    <span>
                        HYDERABAD • TECHNOLOGY • CAREERS
                    </span>

                    <h3>
                        Build Skills for
                        <strong>
                            {" "}Today's Technology Industry.
                        </strong>
                    </h3>

                </div>

                <p>
                    Develop practical technical skills, work on
                    real-world projects and strengthen your interview
                    readiness for opportunities across the technology
                    ecosystem.
                </p>

            </div>

        </section>
    );
};

export default HiringCompanies;